import { ConfigurationActions, configurationReducer } from "./actions/ConfigurationActions";
import { IConfigurationStore } from "./ConfigurationStore";

export const reducer = (store: IConfigurationStore, action: ConfigurationActions): IConfigurationStore =>
    configurationReducer(store, action);
